import { render } from "./TreeWithNewpopup.vue?vue&type=template&id=a0a53862&scoped=true"
import script from "./TreeWithNewpopup.js?vue&type=script&lang=js"
export * from "./TreeWithNewpopup.js?vue&type=script&lang=js"

import "./TreeWithNewpopup.vue?vue&type=style&index=0&id=a0a53862&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a53862"]])

export default __exports__